import { render, staticRenderFns } from "./ParkingPass.vue?vue&type=template&id=2f7bfa3f&scoped=true&"
import script from "./ParkingPass.vue?vue&type=script&lang=js&"
export * from "./ParkingPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7bfa3f",
  null
  
)

export default component.exports